import axiosApi from "../axiosInstance";

const getAssetMovementList = async (assetMovementId) => {
  try {
    const response = await axiosApi.get(
      `/Report/getAssetMovementReport/${assetMovementId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetMovementList", error);
    return error?.response?.data;
  }
};

const getAssetRequestList = async (assetRequestId) => {
  try {
    const response = await axiosApi.get(
      `/Report/getAssetRequestReport/${assetRequestId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetRequestList", error);
    return error?.response?.data;
  }
};

const getAssetDispatchList = async (assetDispatchId) => {
  try {
    const response = await axiosApi.get(
      `/Report/getAssetDispatchReport/${assetDispatchId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetDispatchList", error);
    return error?.response?.data;
  }
};

const getAssetScrapList = async (assetScrapId) => {
  try {
    const response = await axiosApi.get(
      `/Report/getAssetScrapReport/${assetScrapId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetScrapList", error);
    return error?.response?.data;
  }
};

const getAssetAcknowledgementList = async (assetAcknowledgeId) => {
  try {
    const response = await axiosApi.get(
      `/Report/getAssetAcknowledgementReport/${assetAcknowledgeId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetAcknowledgementList", error);
    return error?.response?.data;
  }
};

const getAssetQuotationList = async (assetQuotationId, quotationTypeId) => {
  try {
    const response = await axiosApi.get(
      `/Report/getAssetQuotationReport/${assetQuotationId}/${quotationTypeId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetQuotationList", error);
    return error?.response?.data;
  }
};

const getAssetMaterialRequestReport = async (materialMrId) => {
  try {
    const response = await axiosApi.get(
      `/Report/getAssetMaterialRequestReport/${materialMrId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetMaterialRequestReport", error);
    return error?.response?.data;
  }
};

const getAssetMaterialMovementOrderReport = async (materialOrderId, userId) => {
  try {
    const response = await axiosApi.get(
      `/Report/getAssetMaterialMovementOrderReport/${materialOrderId}/${userId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error ===> getAssetMaterialMovementOrderReport", error);
    return error?.response?.data;
  }
};

export const reportService = {
  getAssetMovementList,
  getAssetRequestList,
  getAssetDispatchList,
  getAssetScrapList,
  getAssetAcknowledgementList,
  getAssetQuotationList,
  getAssetMaterialRequestReport,
  getAssetMaterialMovementOrderReport,
};
